import { render, staticRenderFns } from "./TextMsg.vue?vue&type=template&id=d9b73de8&"
import script from "./TextMsg.vue?vue&type=script&lang=js&"
export * from "./TextMsg.vue?vue&type=script&lang=js&"
import style0 from "./TextMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports